import React, { useState } from 'react';

import { Modal } from 'components/Modal';
import { useParams } from 'react-router-dom';
import { useReInviteUser } from 'features/companies/api/reInviteUser';
import { Button, Stack } from '@mui/material';
import { useForm } from 'react-hook-form';
import { FormProvider, TextField } from 'components/Form';
import useYupValidationResolver from 'hook/useYupValidationResolver';
import { inviteUserSchema } from '../validation';
import { useAuth } from 'lib/auth';

const getDefaultValues = () => ({
  firstName: '',
  lastName: '',
  companyEmail: '',
  companyName: '',
  phoneNumber: '',
});

export const EditUserModal = ({handleSuccess, open, setOpen, firstName = '', lastName = '', companyEmail = '', userID, phoneNumber= ''}) => {
  const { id } = useParams();
  const { account } = useAuth();
  const [values, setValues] = useState({
    firstName: firstName,
    lastName: lastName,
    companyEmail: companyEmail,
    accountID: account.account_id,
    userID: userID,
    phoneNumber: phoneNumber,
  });

  const handleChange = input => e => {
    setValues({ ...values, [input]: e.target.value });
  }

  const methods = useForm({
    mode: 'onSubmit',
    resolver: useYupValidationResolver(inviteUserSchema),
    values: values,
  });

  const { mutate: sendInvitation } = useReInviteUser(+id);

  const handleClose = () => {
    // methods.reset(setValues(getDefaultValues()));
    setOpen(false);
  };

  const onSuccess = () => {
    handleSuccess();
    handleClose();
  };

  const onSubmit = async (values) => {
    return sendInvitation(values, { onSuccess });
  }; 

  return (
    <>
      <Modal title="Invite Contact" open={open} handleClose={handleClose}>
        <FormProvider methods={methods} onSubmit={onSubmit}>
          <Stack>
            <TextField
              name="firstName"
              label="First Name"
              placeholder="Please enter user's first name"
              required={true}
              type="text"
              value={values.firstName}
              onChange={handleChange('firstName')}
              sx={{ mb: 2 }}
              fullWidth
            />
            <TextField
              name="lastName"
              label="Last Name"
              placeholder="Please enter user's last name"
              required={true}
              type="text"
              value={values.lastName}
              onChange={handleChange('lastName')}
              sx={{ mb: 2 }}
              fullWidth
            />
            <TextField
              name="companyEmail"
              label="User's work e-mail"
              placeholder="Please enter user's work e-mail"
              required={true}
              type="email"
              autoComplete="off"
              value={values.companyEmail}
              onChange={handleChange('companyEmail')}
              sx={{ mb: 2 }}
              fullWidth
            />
            <TextField
              name="phoneNumber"
              label="Phone Number"
              placeholder="Please enter user's phone number"
              type="text"
              value={values.phoneNumber}
              onChange={handleChange('phoneNumber')}
              sx={{ mb: 2 }}
              fullWidth
            />
            </Stack>
            <Stack direction="row" gap={3} justifyContent="center">
              <Button variant="outlined" color="primary" onClick={handleClose}>
                Cancel
              </Button>
              <Button variant="contained" color="primary" type="submit">
                Invite
              </Button>
            </Stack>
        </FormProvider>
      </Modal>
    </>
  );
};
